import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';
interface ItemLegendDeskProps {
  widthName: number;
  widthValue: number;
}
function ItemLegendDesk(t0) {
  const $ = _c(8);
  const {
    widthName,
    widthValue
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton className="bg-border h-4 w-4 rounded-full" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== widthName) {
    t2 = <Skeleton className="bg-border h-6 rounded-md" style={{
      width: widthName
    }} />;
    $[1] = widthName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== widthValue) {
    t3 = <Skeleton className="bg-border h-6 rounded-md" style={{
      width: widthValue
    }} />;
    $[3] = widthValue;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex h-fit w-full flex-row items-center gap-2">{t1}{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export { ItemLegendDesk };